<template>

  <!-- Top bar -->
  <ui-top-app-bar
      class="nav-bar"
      content-selector=".app-content"
      nav-id="demo-menu"
      :nav-icon="logged_in?'menu':'false'"
      title="Bob"
    >
      <template #default={}>
        <div class="logo">
          <img alt="Vue logo" style="" src="./assets/logo/logo_white.svg">
        </div>
        <div v-if="activity && path==`/activity/${activity.id}`" class="activity-name">
          {{activity.name}}
        </div>
        <div v-if="!logged_in" id="nav">
          <div class="nav-el" :class="{ active: this.$router.currentRoute.value.path === '/login'}" v-if="!logged_in">
            <router-link to="/login">Login</router-link>
          </div>
          <div class="nav-el" :class="{ active: this.$router.currentRoute.value.path === '/register'}" v-if="!logged_in">
            <router-link to="/register">Register</router-link>
          </div>
        </div>
      </template>

      <!-- nav bar action on right -->
      <template #toolbar="{ toolbarItemClass }">
        <div class="logo">
          v14
        </div>
        <ui-icon-button v-if="logged_in" :class="toolbarItemClass" icon="account_circle" @click="open_settings"></ui-icon-button>
      </template>
  </ui-top-app-bar>


  <!-- Drawer -->
  <ui-drawer type="dismissible" viewport-height nav-id="demo-menu" v-model="show_drawer" @nav="set_side_bar_status">
    <ui-drawer-header>
      <ui-drawer-title>Together Challenge</ui-drawer-title>
      <!-- <ui-drawer-subtitle></ui-drawer-subtitle> -->
    </ui-drawer-header>
    <ui-drawer-content>
      <ui-nav>
        <ui-button style="margin:0 8px">
          <router-link to="/activities">
          Activities 
          </router-link>
        </ui-button>
        <!-- <router-link to="{ name: 'activities', params: {create:true } }">
          <ui-icon-button class="add_activitise_button" icon="control_point"></ui-icon-button>
        </router-link> -->
        <hr>
        <ui-nav-item v-for="activity in activities" :active="path==`/activity/${activity.id}`" :key="activity.id" @click="open_activity(activity.id)" href="javascript:void(0)">
            {{activity.name}}
        </ui-nav-item>

      </ui-nav>
    </ui-drawer-content>
  </ui-drawer>

  <!-- Page content -->
  <ui-drawer-app-content class="app-content" :class="{mobile:is_mobile}">
      <router-view/>
  </ui-drawer-app-content>

  
  
</template>

<script>

import { mapState, mapGetters } from 'vuex'
import {useRoute} from 'vue-router'
import {computed,watch} from 'vue'

window.mobileCheck = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

export default {
  data(){
    return {
        show_drawer: true
    }
  },
  computed: {
    path(){
      return this.$router.currentRoute.value.path;
    },
    is_mobile(){
      return ( navigator.userAgentData && navigator.userAgentData.mobile ) || window.mobileCheck()
    },
    activities(){
      return this.$store.state.activities
    },
    activity(){
      return this.$store.state.activity
    },
    ...mapState({
      'logged_in': state => state.users.logged_in,
    }),
  },
  methods:{
    open_activity(activity_id){
      this.$store.commit('set_activity_id', activity_id)
      this.$router.push({name:`Activity`, params:{id:activity_id }} )
      
      this.show_drawer = !this.is_mobile
    },
    open_settings(){
      this.$router.push('/settings')
    },
    set_side_bar_status(open){
        this.show_drawer = open
    }
  },
  created(){
    if ( this.logged_in && !this.$router.currentRoute.value.path !== "/activities"){
      // this.$store.dispatch("get_activities")
      this.show_drawer = !this.is_mobile
    } else {
      this.show_drawer = !this.is_mobile
    }

  }
}
</script>


<style>
body {
  margin: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

/* Nav bar */
.logo {
  display: inline-block;
  color: white;
  padding-inline-end: 10px;
}
.logo img {
  height:40px;
  vertical-align:middle;
}
.nav-bar .mdc-top-app-bar__title {
  padding: 0;
  flex-grow: 1;
  display: flex;
  justify-content: space-between;
}

.nav-el{
  display: inline-block;
  padding: 10px;
}
#nav a {
  height:2em;
  font-weight: bold;
  color: white;
}
#nav .active a.router-link-exact-active {
  color: white;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
.activity-name {
  display: inline-block;
  padding: 0 10px;
}
.mdc-top-app-bar.nav-bar {
  z-index: 7;
}

/* app */
.content {
  max-width: 1000px;
  margin: auto;
}


.app-content {
  width: 100%;
  height: 100%;
  overflow: auto;
}

.app-content.mobile {
  margin-left: 0px !important;
}

.add_activitise_button {
  vertical-align: bottom;
}
</style>
